import React, { Component } from 'react';
import Select from 'react-select';
import {withRouter} from "react-router-dom";
import './search.css';
import Location from '../../static/img/location.svg';

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getPosition = (options) => {
    return new Promise(function (resolve, reject) {
      navigator.geolocation.getCurrentPosition(resolve, reject, options);
    });
  }

  componentDidMount() {
    fetch(`https://ipapi.co/json/`)
      .then((response) => {
        if (!response.ok) { throw response }
        return response.json()  //we only get here if there is no error
      })
      .then((json) => {
        this.setState({
          lat: json.latitude,
          lon: json.longitude,
          countryCode: json.country
        })
      })
  }

  onChange = (val) => {
    this.setState({
      value: val,
      focusStyle: {}
    });
    
    document.activeElement.blur();
    this.props.isLoading(true);
    
    if (val) {
      if (val.value === 'geolocate') {
        this.getPosition().then((position) => {
          fetch(`//geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?f=pjson&location=${position.coords.longitude},${position.coords.latitude}`)
            .then((response) => response.json())
            .then((json) => {
              if (json.address.CountryCode === 'IRL') 
              {
                const address = json.address.Address;
                const lat = position.coords.latitude;
                const long = position.coords.longitude;
                const type = 'Current';
  
                this.props.history.push(
                  {
                    pathname: `/stats/${lat}/${long}/${type}`,
                    search: `?address=${address}`
                  }
                );
              } else {
                // show warning about outside IRL
              }
              
          });
        }).catch((err) => {
          console.error(err.message);
        });
      } else {
        const magicKey = (val.className !== "Select-create-option-placeholder") ? `&magicKey=${val.magicKey}` : ``;

        let location = '';
        if (magicKey === ``) {
          if (this.props.client) {
            location = `&location=${this.props.client.longitude},${this.props.client.latitude}`
          } else if ((this.state.lon && this.state.lat) && (this.state.countryCode === 'IE')) {
            location = `&location=${this.state.lon},${this.state.lat}`;
          }
        }
  
        fetch(`//geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates?SingleLine=${val.text}${magicKey}${location}&outFields=*&forStorage=false&f=pjson&sourceCountry=IRL&maxLocations=1`)
          .then((response) => response.json())
          .then((json) => {
            try {
              const address = json.candidates[0].address;
              const lat = json.candidates[0].location.y;
              const long = json.candidates[0].location.x;
              const type = json.candidates[0].attributes.Addr_type;
              this.props.history.push(
                {
                  pathname: `/stats/${lat}/${long}/${type}`,
                  search: `?address=${address}`
                }
              );
            } catch(e) {
              this.props.isLoading(false);
              console.log(e);
            }
          });
        }
      }
  }

  handleFocus = () => {
    if (this.props.mobileEnlarge) {
      this.setState({
        focusStyle: {
          width: "calc(100% - 2rem)",
          margin: "0 1rem",
          position: "absolute",
          padding: "0",
          top: "16px",
          left: 0,
        }
      })
    } else if (typeof window !== 'undefined' && (window.innerWidth <= 500)) {
      this.textInput.select.wrapper.scrollIntoView(true)
    }
  }

  handleBlur = () => {
    this.setState({
      focusStyle: {}
    })
  }

  getSuggestions = (input) => {
    if (!input) {
      if ('geolocation' in navigator) {
        return Promise.resolve({ options: [{text: <span style={{ display: "flex", alignItems: "center" }}><img src={Location} height="16px" width="16px" style={{ marginRight: "10px" }}/> Find my current location</span>, value: 'geolocate'}] });
      } else {
        return Promise.resolve({ options: [] });
      }
    }

    let location = '';
    if (this.props.client) {
      location = `&location=${this.props.client.longitude},${this.props.client.latitude}`
    } else if ((this.state.lon && this.state.lat) && (this.state.countryCode === 'IE')) {
      location = `&location=${this.state.lon},${this.state.lat}`;
    }

    return fetch(`//geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?text=${input}&countryCode=IRL&maxSuggestions=8&f=pjson${location}&category=Street Address, Street Name`)
      .then((response) => response.json())
      .then((json) => {
        return { options: json.suggestions };
      });
  }

  render() {
    return (
      <div style={this.state.focusStyle}>
        <Select.AsyncCreatable
          ref={(input) => { this.textInput = input; }}
          valueKey="magicKey"
          labelKey="text"
          placeholder={this.props.defaultValue ? this.props.defaultValue : `Search for an address`}
          loadOptions={this.getSuggestions}
          onChange={this.onChange}
          value={this.state.value}
          promptTextCreator={(string) => { return `Search for "${ string }"`}}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          onBlurResetsInput={false}
          onCloseResetsInput={false}
          arrowRenderer={null}
        ></Select.AsyncCreatable>
      </div>
    );
  }
}

Search.defaultProps = { 
  isLoading: () => {}
};

export default withRouter(Search);


// WEBPACK FOOTER //
// ./src/components/search/index.js